import type { Translation } from '../types.ts';
import type en from '../en/giftcards.ts';

export default {
    index: {
        title: 'Cadeaubonnen',
        intro: 'Cadeaubonnen voor {website}.',
        noWebsite: 'Kies eerst een website om de cadeaubonnen ervan te beheren.',
    },
    status: {
        disabled: 'Uitgeschakeld',
        expired: 'Verlopen',
        spent: 'Opgebruikt',
        partSpent: 'Deels gebruikt',
        unused: 'Ongebruikt',
    },
    delivery: {
        sent: 'Verstuurd {date}',
        scheduled: 'Gepland {date}',
        notSent: 'Niet verstuurd',
    },
    panel: {
        intro: 'Cadeaubonnen die in de winkel zijn verkocht, plus de bonnen die je zelf uitgeeft.',
        outstanding: 'Openstaand saldo: {amount}.',
        issueCard: 'Cadeaubon uitgeven',
        issueTitle: 'Een cadeaubon uitgeven',
        issueHelp: 'Voor een bon waar niemand voor heeft betaald: als gebaar na een klacht, voor een actie, of een fysieke bon die aan de balie is verkocht. Hij werkt precies als een gekochte bon. Er wordt niets gemaild totdat je op Versturen in de rij drukt.',
        amountHint: 'In euro, bijvoorbeeld 50 of 12,50.',
        recipientName: 'Naam ontvanger',
        recipientNameHint: 'Optioneel. Wordt gebruikt in de aanhef.',
        recipientEmail: 'E-mail ontvanger',
        recipientEmailPlaceholder: "oma{'@'}example.com",
        recipientEmailHint: 'Optioneel. Laat leeg voor een bon die je persoonlijk overhandigt.',
        issue: 'Bon uitgeven',
        empty: 'Nog geen cadeaubonnen. Ze verschijnen hier zodra klanten ze kopen, of je kunt er zelf een uitgeven.',
        balance: 'Saldo',
        for: 'Voor',
        delivery: 'Bezorging',
        enabled: 'Actief',
        ofInitial: 'van {amount}',
        ledger: 'Waar het geld naartoe ging',
        sendByEmail: 'Deze bon per e-mail versturen',
        created: 'Cadeaubon aangemaakt',
        confirmSendTo: 'Cadeaubon {code} nu naar {to} versturen?',
        confirmSend: 'Cadeaubon {code} nu naar de ontvanger versturen?',
        sent: 'Cadeaubon verstuurd',
    },
    ledger: {
        title: 'Bon {code}',
        issued: 'Uitgegeven',
        byHand: '(handmatig)',
        boughtBy: 'Gekocht door',
        expires: 'Verloopt',
        never: 'Nooit',
        nothingSpent: 'Nog niets besteed: het volledige bedrag van {amount} staat nog op de bon.',
        when: 'Wanneer',
        order: 'Bestelling',
        spent: 'Besteed',
        leftAfter: 'Saldo daarna',
        held: 'gereserveerd, wacht op betaling',
        released: 'teruggezet {date}',
    },
} satisfies Translation<typeof en>;
